import Vue from 'vue'
const closeModal = new Vue()
export default closeModal



// WEBPACK FOOTER //
// ./client/events/closeModal.js